export default __webpack_public_path__ + "static/media/logo_yellow_circle.46475664.png";